import { createFileRoute } from "@tanstack/react-router";

import Overview from "~/pages/UsdaAudit/Overview";
import { ROUTE_STATIC } from "~/utils/routeStaticData";

export const Route = createFileRoute("/_private/usda-audit/")({
  staticData: ROUTE_STATIC.usdaAudit,
  component: Overview,
});
